"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPPaymentInfoComponent = void 0;
const core_1 = require("@angular/core");
const expresspay_services_1 = require("../../../shared/services/expresspay.services");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const helper_service_1 = require("../../../../mma/shared/services/helper.service");
const shared_1 = require("../../../../mma/shared");
const _ = require("underscore");
const rxjs_1 = require("rxjs");
const cs_thirdpartypayments_web_1 = require("@cspire/cs-thirdpartypayments-web");
const constants_1 = require("../../../shared/constants");
class CSEPPaymentInfoComponent {
    constructor(expressPayService, helperService, genericContentService, modalService, tokenService) {
        this.expressPayService = expressPayService;
        this.helperService = helperService;
        this.genericContentService = genericContentService;
        this.modalService = modalService;
        this.tokenService = tokenService;
        this.next = new core_1.EventEmitter();
        this.billingAddress = new core_1.EventEmitter();
        this.paymentDetails = new core_1.EventEmitter();
        this.giftCardDetails = new core_1.EventEmitter();
        this.bankPayDetails = new core_1.EventEmitter();
        this.getPaymentMethod = new core_1.EventEmitter();
        this.contentSavedCC = new core_1.EventEmitter();
        this.saveBankInfo = new core_1.EventEmitter();
        this.confirmationNum = new core_1.EventEmitter();
        this.genericError904 = new core_1.EventEmitter();
        this.confirmPayment = new core_1.EventEmitter();
        this.thirdPartyPaymentResponse = new core_1.EventEmitter();
        this.getConvenienceFee = new core_1.EventEmitter();
        this.classes = 'col-12';
        this.cardMonth = [
            '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
        ];
        this.cardYear = new Array();
        this.inputFieldsAddressOptional = new Array();
        this.inputFieldsAddress = new Array();
        this.inputFieldsCity = new Array();
        this.inputFieldsState = new Array();
        this.inputFieldsZip = new Array();
        this.inputFieldsCvv = new Array();
        this.oauthStatus = new rxjs_1.Subject();
        this.emitOauthStatusObs$ = this.oauthStatus.asObservable();
        // 3rd Party Payment
        this.clientName = cs_thirdpartypayments_web_1.ClientName.MMAEXPRESS;
        this.lob = constants_1.LOB.WIRELESS;
        this.requireShipping = false;
        this.showThirdPartyPayments = false;
        this.scrollTop();
    }
    ngOnInit() {
        var _a;
        this.hideDifferentCardOption = false;
        // to check if the user has valid session or not
        this.isAuthenticated();
        this.getErrorMessage();
        this.getStates();
        this.getBillingAddress();
        this.CcYear();
        this.isBankOptionAvailable();
        this.hideDifferentCardOption = true;
        this.newCard = 'newCreditDebitCard';
        this.address = 'newAddress';
        // adding code for PCI compliance
        this.getTokenServiceErrorJson();
        this.payDetails = { paymentAmount: (_a = this.funds) === null || _a === void 0 ? void 0 : _a.amountToPay.toString() };
        this.getGenericContentText();
    }
    getBillingAddress() {
        this.payByDiffCcardAddr = 'billingAddr';
        this.error = null;
        this.expressPayService.getPersonalInformation().subscribe((res) => {
            this.personalInfo = res;
            this.getStartedUrl = '/online-warranty/?mobileNumber=' + this.personalInfo.mobileNumber;
            // Get service fee for credit card
            this.getCreditCardServiceFee();
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getStates() {
        this.expressPayService.getAllStatesList().subscribe((data) => {
            this.stateList = data;
        }, (err) => {
        });
    }
    CcYear() {
        const d = new Date();
        let n = d.getFullYear();
        this.cardYear.push(n);
        for (let i = 0; i <= 9; i++) {
            n = n + 1;
            this.cardYear.push(n.toString());
        }
    }
    isBankOptionAvailable() {
        this.loader = true;
        this.error = null;
        this.expressPayService.checkBankAvailabilityOption().subscribe((res) => {
            this.loader = false;
            if (res.checkPayPostPaidStatus === true) {
                this.bankOptionAvailable = true;
            }
            else {
                this.bankOptionAvailable = false;
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    getErrorMessage() {
        this.expressPayService.getCSErrorMessage().subscribe((res) => {
            this.feErrorMsg = res;
        }, (err) => {
        });
    }
    submit(card, paymentMethod, paymentType, details, funds, mdn, subId, address, addressSavedCard, count) {
        this.scrollTop();
        const selectedPaymentMethod = {
            setPaymentMethod: paymentMethod,
            setCCardMethod: card,
            setAddressSavedCard: addressSavedCard,
            setCount: count,
            setAddress: address
        };
        let content = {};
        if (paymentMethod === 'BANK_ACCOUNT') {
            this.address = details.billingAddress;
            // WEBI: 3812 added address parameter
            content = this.payByBankAccount(details, funds, this.address);
            this.saveBankInfo.emit(details.saveBankInfo);
            this.loader = true;
            this.error = null;
            this.expressPayService.saveBankAccountDetails(content).subscribe((data) => {
                this.loader = false;
                this.bankPayDetails.emit(content);
                this.getPaymentMethod.emit(selectedPaymentMethod);
                this.next.emit(true);
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
        }
        else if (paymentMethod === 'GIFT_CARD') {
            if (details.giftCardNumber !== undefined && details.giftCardPin !== undefined && !this.showBalance) {
                this.getgiftCardDetails(details);
            }
            else {
                this.loader = true;
                this.subscription = this.getOauthAccessToken().subscribe((token) => {
                    this.loader = false;
                    if (!_.isEmpty(token)) {
                        const giftCardData = this.tokenService.getGiftCardRequest(details.giftCardNumber);
                        const bearerToken = 'Bearer ' + this.oauthAccessToken;
                        this.getSaveGiftCardToken(details, giftCardData, bearerToken, this.paymentUrl, funds, selectedPaymentMethod, paymentType);
                    }
                    this.subscription.unsubscribe();
                }, (err) => {
                    this.error = err;
                    this.loader = false;
                });
            }
        }
        else {
            this.nextSection(card, details, funds, address, addressSavedCard, selectedPaymentMethod);
        }
    }
    getgiftCardDetails(giftCardValue) {
        this.scrollTop();
        this.subscription = this.getOauthAccessToken().subscribe((token) => {
            if (!_.isEmpty(token)) {
                const giftCardData = this.tokenService.getGiftCardRequest(giftCardValue.giftCardNumber);
                const bearerToken = 'Bearer ' + this.oauthAccessToken;
                this.getCheckGiftCardToken(giftCardValue, giftCardData, bearerToken, this.paymentUrl);
                this.subscription.unsubscribe();
            }
        });
    }
    // WEBI: 3812 added address parameter. Populate based on user selected
    payByBankAccount(details, funds, address) {
        let content = {};
        // WEBI : 3812 Address fields.
        const SameAsBillingAddr = 'diff_address';
        const addressLine1 = details.addressLine1;
        const addressLine2 = details.addressLine2;
        const selectedCity = details.city;
        const selectedState = details.state;
        const zipCode = details.zipCode;
        if (details.saveBankInfo === undefined) {
            details.saveBankInfo = false;
        }
        content = {
            'amountToPay': funds.amountToPay,
            'payInFull': funds.payInFull,
            'payPastDueBalance': funds.payPastDueBalance,
            'termsAndConditions': details.termscondition,
            'savePaymentInfo': details.saveBankInfo,
            'bankAccount': {
                'routingNumber': details.routingNumber,
                'routingNumberConfirm': details.routingNumberConfirm,
                'bankAccountNumber': details.accountNumber,
                'bankAccountNumberConfirm': details.accountNumberConfirm,
                'checkNumber': '1',
                'checkType': details.consumerType,
                'differentBankAccount': true,
                'address': {
                    'addressSelected': SameAsBillingAddr,
                    'firstName': details.firstName,
                    'lastName': details.lastNmae,
                    addressLine1,
                    addressLine2,
                    'city': selectedCity,
                    'state': selectedState,
                    zipCode
                }
            }
        };
        return content;
    }
    nextSection(card, newDetails, funds, address, addressSavedCard, selectedPaymentMethod) {
        if (card === 'newCreditDebitCard') {
            this.storeNewCardDetails(newDetails, address);
            // this.storeDetailsSavedCard(newDetails);
            this.subscription = this.getOauthAccessToken().subscribe((token) => {
                if (!_.isEmpty(token)) {
                    this.paymentByCardJson(funds, address, selectedPaymentMethod, newDetails);
                }
                this.subscription.unsubscribe();
            });
        }
    }
    paymentByCardJson(funds, address, selectedPaymentMethod, ccDetails) {
        const amountToPay = parseFloat(funds.amountToPay);
        const creditCardData = this.tokenService.getCreditCardRequest(this.payment, this.address, amountToPay);
        const bearerToken = 'Bearer ' + this.oauthAccessToken;
        this.getCreditCardToken(funds, address, selectedPaymentMethod, ccDetails, creditCardData, bearerToken, this.paymentUrl);
    }
    storeNewCardDetails(newDetails, address) {
        this.saveCreditCardOption = newDetails.ccTermsCondition;
        this.payment = {
            creditCardNumber: newDetails.cardNumber,
            expirationMonth: newDetails.cardExpirationMonth,
            expirationYear: newDetails.cardExpirationYear,
            creditCardType: newDetails.creditCardType,
            cvv: newDetails.cvv,
            index: this.indexoFCard
        };
        if (address === 'newAddress') {
            this.address = {
                city: newDetails.city,
                state: newDetails.state,
                zip: newDetails.zipCode,
                address1: newDetails.addressLine1,
                firstName: newDetails.firstName,
                lastName: newDetails.lastName,
                saveCardInfo: this.saveCreditCardOption
            };
        }
        if (address === 'billingAddr') {
            this.address = {
                city: newDetails.city,
                state: newDetails.state,
                zip: newDetails.zipCode,
                address1: newDetails.addressLine1,
                firstName: newDetails.firstName,
                lastName: newDetails.lastName,
                saveCardInfo: this.saveCreditCardOption
            };
        }
    }
    getCvvDetail() {
        this.open(this.cvvDetails);
    }
    payCheckDisabled() {
        this.expressPayService.genericContentPayTemporarilyDisabled()
            .subscribe((data) => {
            this.checkPayTemporarilyDisabled = data.contentText;
        }, (err) => {
        });
    }
    payByCreditCard() {
        this.error = null;
    }
    payByDiffBankCard() {
        this.error = null;
        window.scrollTo(0, 300);
        this.diffBankPaybillingAddress = 'DIFFERENT_ADDRESS';
    }
    selectPaymentByGiftCard() {
        window.scrollTo(0, 600);
    }
    open(content) {
        this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    scrollTop() {
        window.scrollTo(0, 200);
    }
    openCheckImage() {
        this.open(this.checkImgContent);
    }
    openTT() {
        this.tooltip.open();
    }
    closeTT() {
        this.tooltip.close();
    }
    emitOauthStatus(change) {
        this.oauthStatus.next(change);
    }
    getTokenServiceErrorJson() {
        this.tokenService.getCSErrorMessage().subscribe((res) => {
            this.tokenErrorMessage = res;
        }, (err) => {
        });
    }
    getTokenServiceErrorMessage(error) {
        const errorJson = this.tokenErrorMessage;
        let errorMessage;
        if (error.status === 0 || error.statusText === 'error' || error.status === 500) {
            errorMessage = errorJson['401'];
        }
        else {
            if (error.code !== undefined && error.code !== null) {
                errorMessage = errorJson[error.code];
            }
            else {
                errorMessage = errorJson['000'];
            }
        }
        if (errorMessage !== undefined && errorMessage !== null) {
            const errorMap = {
                'code': error.code,
                'message': errorMessage
            };
            this.error = errorMap;
            this.loader = false;
        }
        else {
            this.error = error;
            this.loader = false;
        }
    }
    getOauthAccessToken() {
        this.error = null;
        this.loader = true;
        this.tokenService.getOauthAccessToken().subscribe((data) => {
            this.oauthAccessToken = data.accessToken;
            this.paymentUrl = data.paymentTokenUrl;
            const bearerToken = 'Bearer ' + this.oauthAccessToken;
            this.emitOauthStatus(bearerToken);
            return this.emitOauthStatusObs$;
        }, (err) => {
            this.error = err;
            this.loader = false;
            return null;
        });
        return this.emitOauthStatusObs$;
    }
    getCreditCardToken(funds, address, selectedPaymentMethod, ccDetails, data, header, paymentUrl) {
        this.loader = true;
        // converting card expYear from String to Int
        if (data != null && data !== undefined) {
            data.card['expYear'] = parseInt(data.card.expYear, 10);
        }
        // ccDetails["month"] = parseInt(ccDetails.yea)
        const creditCardType = this.tokenService.getCardType(ccDetails.cardNumber);
        this.tokenService.getPaymentToken(data, header, paymentUrl).subscribe((resp) => {
            this.loader = false;
            let SameAsBillingAddr;
            if (address === 'newAddress') {
                SameAsBillingAddr = false;
            }
            else {
                SameAsBillingAddr = true;
            }
            if (ccDetails.ccTermsCondition === undefined) {
                ccDetails.ccTermsCondition = false;
            }
            const content = {
                amountToPay: funds.amountToPay,
                savePaymentInfo: ccDetails.ccTermsCondition,
                prepaid: false,
                payInFull: funds.payInFull,
                payPastDueBalance: funds.payPastDueBalance,
                termsAndConditions: ccDetails.ccTermsCondition,
                convenienceFeeAmount: this.convenienceFeeAmount,
                creditCard: {
                    newCreditCard: true,
                    ccAddrSameAsBillingAddr: SameAsBillingAddr,
                    ccNumber: resp.token,
                    expMonth: this.payment.expirationMonth,
                    expYear: this.payment.expirationYear,
                    cvv: this.payment.cvv,
                    kHashToken: resp.khash,
                    ccType: creditCardType,
                    ccAddress: {
                        addressSelected: 'saved',
                        firstName: this.address.firstName,
                        lastName: this.address.lastName,
                        addressLine1: this.address.address1,
                        addressLine2: '',
                        city: this.address.city,
                        state: this.address.state,
                        zipCode: this.address.zip
                    }
                }
            };
            this.paymentDetails.emit(this.payment);
            this.billingAddress.emit(this.address);
            this.contentSavedCC.emit(content);
            this.getPaymentMethod.emit(selectedPaymentMethod);
            this.next.emit(true);
        }, (err) => {
            this.getTokenServiceErrorMessage(err);
            this.address = 'billingAddr';
        });
    }
    getCheckGiftCardToken(details, data, header, paymentUrl) {
        this.loader = true;
        this.tokenService.getPaymentToken(data, header, paymentUrl).subscribe((resp) => {
            // this.checkBalanceLoader = true;
            this.showError = false;
            this.expressPayService.getGiftCardBalanceDetails(resp.token, details.giftCardPin)
                .subscribe((res) => {
                this.selectPaymentByGiftCard();
                this.cardNumber = details.giftCardNumber;
                this.showBalance = true;
                this.balance = res.availableBalance;
                // this.checkBalanceLoader = false;
                this.loader = false;
                this.error = null;
            }, (err) => {
                this.showError = true;
                this.error = err;
                this.showBalance = false;
                // this.checkBalanceLoader = false;
                this.loader = false;
                this.scrollTop();
            });
        }, (err) => {
            this.getTokenServiceErrorMessage(err);
        });
    }
    getSaveGiftCardToken(details, data, header, paymentUrl, funds, selectedPaymentMethod, paymentType) {
        this.loader = true;
        this.tokenService.getPaymentToken(data, header, paymentUrl).subscribe((resp) => {
            const content = {
                'amountToPay': funds.amountToPay,
                'payInFull': funds.payInFull,
                'payPastDueBalance': funds.payPastDueBalance,
                'giftCard': {
                    'gcNumber': resp.token,
                    'gcPin': details.giftCardPin,
                    'gcBalance': this.balance,
                }
            };
            // save gift card details
            this.expressPayService.savePaymentByGiftCard(content).subscribe((res) => {
                this.SaveBankData = res;
                this.cardNumber = details.giftCardNumber;
                const giftCard = {
                    giftCardNumber: resp.token,
                    giftCardPin: details.giftCardPin,
                    giftCardAmount: funds.amountToPay,
                    giftCardBalance: this.balance
                };
                this.giftCardDetails.emit(giftCard);
                this.getPaymentMethod.emit(selectedPaymentMethod);
                this.next.emit(true);
            }, (err) => {
                this.error = err;
                this.scrollTop();
                this.loader = false;
            });
        }, (err) => {
            this.getTokenServiceErrorMessage(err);
        });
    }
    // code to check if the user has valid session or not
    isAuthenticated() {
        this.loader = true;
        this.expressPayService.loginAuthentication().subscribe((data) => {
            if (_.isEmpty(data)) {
                this.hidePage = true;
                this.helperService.onNavigate('/my_account/personal/express-pay/');
            }
            this.loader = false;
        }, (err) => {
            this.loader = false;
        });
    }
    handlePaymentResult(paymentResponse) {
        this.scrollTop();
        // handle response success/failure
        if ((paymentResponse === null || paymentResponse === void 0 ? void 0 : paymentResponse.paymentId) && (paymentResponse === null || paymentResponse === void 0 ? void 0 : paymentResponse.authCode) && !(paymentResponse === null || paymentResponse === void 0 ? void 0 : paymentResponse.error)) {
            this.confirmationNum.emit(paymentResponse.authCode);
            this.thirdPartyPaymentResponse.emit(paymentResponse);
            this.confirmPayment.emit(true);
        }
        else {
            this.error = paymentResponse.error;
            this.genericError904.emit(paymentResponse.error);
        }
    }
    handleShowThirdPartyPayments(showThirdPartyPayments) {
        this.showThirdPartyPayments = showThirdPartyPayments;
    }
    getCreditCardServiceFee() {
        const tenderFeeRequest = {
            tenderType: cs_thirdpartypayments_web_1.TenderTypes.CREDIT_CARD,
            amount: this.funds.amountToPay,
            clientName: this.clientName,
            lineOfBusiness: this.lob
        };
        this.expressPayService.getServiceFee(tenderFeeRequest).subscribe((res) => {
            this.convenienceFeeAmount = res.feeAmount;
            this.totalDueAmount = res.totalAmountWithFee;
            this.getConvenienceFee.emit(this.convenienceFeeAmount);
        }, () => {
            var _a;
            this.convenienceFeeAmount = 0;
            this.totalDueAmount = (_a = this.funds) === null || _a === void 0 ? void 0 : _a.totalDueToday;
        });
    }
    getGenericContentText() {
        const contents = [
            'genericContentThirdPartyConvenienceFee',
            'genericConvenienceFeeNote',
            'genericContentCVV'
        ];
        this.genericContentService.getBulkGenericContent(contents).subscribe((data) => {
            for (const content of data) {
                if (content.id === 'genericContentThirdPartyConvenienceFee') {
                    this.genericContentThirdPartyConvenienceFee = content.content;
                }
                if (content.id === 'genericConvenienceFeeNote') {
                    this.convenienceFeeNote = content.content;
                }
                if (content.id === 'genericContentCVV') {
                    this.cvvText = content.content;
                }
            }
        }, (err) => {
            this.error = err;
        });
    }
}
exports.CSEPPaymentInfoComponent = CSEPPaymentInfoComponent;
//# sourceMappingURL=paymentinfo.component.js.map